import { render, staticRenderFns } from "./TableCmp.vue?vue&type=template&id=02160e6a&scoped=true"
import script from "./TableCmp.vue?vue&type=script&lang=js"
export * from "./TableCmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02160e6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02160e6a')) {
      api.createRecord('02160e6a', component.options)
    } else {
      api.reload('02160e6a', component.options)
    }
    module.hot.accept("./TableCmp.vue?vue&type=template&id=02160e6a&scoped=true", function () {
      api.rerender('02160e6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/cope/quotationManagement/cmp/CollectionAndDoorToDoorCollectionAndThirdPartyCmp/TableCmp.vue"
export default component.exports